import api from '../api';
import { PROPERTY_MANAGER_METADATA_ENDPOINT } from '../endpoints';

export default {
    namespaced: true,
    state() {
        return {
            metadata: null,
        };
    },
    getters: {
        metadata: (state) => state.metadata,
    },
    mutations: {
        setMetadata(state, metadata) {
            state.metadata = metadata;
        },
    },
    actions: {
        async fetchMetadata({ commit }) {
            const { data } = await api.get(PROPERTY_MANAGER_METADATA_ENDPOINT());
            commit('setMetadata', data);
        },
        async submitMetadata({ dispatch }, metadata) {
            await api.post(PROPERTY_MANAGER_METADATA_ENDPOINT(), metadata);
            dispatch('fetchMetadata');
        },
    },
};
